import { Link, useLocation } from "react-router-dom";
import { useInquiry } from "@/components/InquiryModal";

const TITLES = {
  "/services": "Services",
  "/pricing": "Pricing",
  "/portfolio": "Portfolio",
  "/about": "About",
  "/contact": "Contact",
  "/privacy": "Privacy Policy (Draft)",
  "/terms": "Terms of Service (Draft)",
};

const ComingSoon = () => {
  const { pathname } = useLocation();
  const { open } = useInquiry();
  const title = TITLES[pathname] || "This Page";

  return (
    <main data-testid="coming-soon-page" className="bg-cream min-h-[80vh] pt-[72px] flex items-center">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center w-full">
        <p className="text-xs font-sans uppercase tracking-[0.28em] font-semibold text-turquoise-deep mb-6">
          Coming Soon
        </p>
        <h1 className="font-serif font-medium tracking-tight text-charcoal text-4xl sm:text-5xl">
          {title}
        </h1>
        <p className="mt-5 font-sans text-base text-taupe max-w-md mx-auto leading-relaxed">
          We're putting the finishing touches on this page. In the meantime, we'd love to hear about
          your project.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            data-testid="coming-soon-cta-button"
            onClick={open}
            className="bg-turquoise text-charcoal hover:bg-turquoise-dark px-9 py-4 rounded-full font-sans font-semibold text-base transition-colors duration-300"
          >
            Get My Website
          </button>
          <Link
            data-testid="coming-soon-home-link"
            to="/"
            className="border-2 border-charcoal text-charcoal hover:bg-charcoal hover:text-cream px-9 py-4 rounded-full font-sans font-medium text-base transition-colors duration-300"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </main>
  );
};

export default ComingSoon;
